import React from "react";
import ReactMarkdown from "react-markdown";
import "./styles/Message.css";

function Message({ text, sender, timestamp }) {
  const formatTime = (date) => {
    return new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  };

  if (sender === "system") {
    return (
      <div className="message-container system-message">
        <div className="message-bubble">
          <div className="message-text">
            <span className="system-message-content">{text}</span>
          </div>
          <div className="message-time">{formatTime(timestamp)}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`message-container ${
        sender === "user" ? "user-message" : "agent-message"
      }`}
    >
      <div className="message-bubble">
        <div className="message-text">
          <ReactMarkdown>{text}</ReactMarkdown>
        </div>
        <div className="message-time">{formatTime(timestamp)}</div>
      </div>
    </div>
  );
}

export default Message;
